'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'lightbulb-on';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f672';
var svgPathData = 'M496 192c0 46.9-18.3 89.5-48.3 121.1-21.7 22.9-42.4 52.4-46.8 86.9l-161.8 0c-4.5-34.5-25.1-64-46.8-86.9-29.9-31.6-48.3-74.2-48.3-121.1 0-97.2 78.8-176 176-176S496 94.8 496 192zM240 416l160 0 0 16c0 35.3-28.7 64-64 64l-32 0c-35.3 0-64-28.7-64-64l0-16zm176-2.3C416 379.4 435.7 349 459.3 324.1 492 289.7 512 243.2 512 192 512 86 426 0 320 0S128 86 128 192c0 51.2 20 97.7 52.7 132.1 23.6 24.9 43.3 55.3 43.3 89.6l0 18.3c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-18.3zM312 96c4.4 0 8-3.6 8-8s-3.6-8-8-8c-57.4 0-104 46.6-104 104 0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88zM36.4 25.3c-3.7-2.5-8.6-1.5-11.1 2.2s-1.5 8.6 2.2 11.1l48 32c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-48-32zm576 13.3c3.7-2.5 4.7-7.4 2.2-11.1s-7.4-4.7-11.1-2.2l-48 32c-3.7 2.5-4.7 7.4-2.2 11.1s7.4 4.7 11.1 2.2l48-32zM16 184c-4.4 0-8 3.6-8 8s3.6 8 8 8l48 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-48 0zm560 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l48 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-48 0zM84.4 326.7c3.7-2.5 4.7-7.4 2.2-11.1s-7.4-4.7-11.1-2.2l-48 32c-3.7 2.5-4.7 7.4-2.2 11.1s7.4 4.7 11.1 2.2l48-32zm480-13.3c-3.7-2.5-8.6-1.5-11.1 2.2s-1.5 8.6 2.2 11.1l48 32c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1l-48-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightbulbOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;